import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { initializeStore } from './_store';
import 'antd/dist/antd.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ThemeProvider, createMuiTheme } from '@material-ui/core';
import confs from './configurations';
import { initializeStorage } from './initStorage';

const { PRIMARY } = confs;

console.log('PRIMARY:', PRIMARY);

// Initialize storage and store asynchronously
(async () => {
    try {
        // Initialize storage first
        await initializeStorage();

        // Then initialize Redux store (now async)
        const store = await initializeStore();

        const theme = createMuiTheme({
            palette: {
                primary: {
                    main: PRIMARY,
                },
            },
        });

        // Render app after storage and store are ready
        ReactDOM.render(
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <App />
                </ThemeProvider>
            </Provider>, document.getElementById('root'));

    } catch (error) {
        console.error('Failed to initialize app:', error);
    }
})();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
